module.exports = __webpack_public_path__ + "static/media/10_wheeloffortune.6ed63bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10_wheeloffortune.png
// module id = 73
// module chunks = 0